export default ({
  pageState: { editorBlocks, editorBlocksOrder },
  data: { blockId, localBlockId, success, updatedAt }
}) => {
  if (!success) return { editorHeaderStatus: 'error' };

  const { [localBlockId]: removedId, ...updatedEditorBlocks } = editorBlocks;
  return {
    editorBlocks: {
      ...updatedEditorBlocks,
      [blockId]: editorBlocks[localBlockId]
    },
    editorBlocksOrder: [
      ...editorBlocksOrder.slice(0, editorBlocksOrder.indexOf(localBlockId)),
      blockId,
      ...editorBlocksOrder.slice(editorBlocksOrder.indexOf(localBlockId) + 1)
    ],
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};
